import { GeneratedTemplateType } from '../types/util-types';

export const QA_DOMAINS = ['staging-qa-app.honeybook.com', 'hbqa.dev'];

export const TRANSLATION_COMPONENTS = {
    sup: <sup />,
    small: <small />,
    p: <p />,
    ul: <ul />,
    li: <li />,
    ol: <ol />,
    strong: <strong />,
    span: <span />,
    a: <a />,
    em: <em />,
    br: <br />
};

export const CLICK_START_TRIAL_ADDITIONAL_DATA_STORAGE_KEY = 'additionalData';
export const CURRENT_REFERER_STORAGE_KEY = 'currentReferrer';
export const DEVICE_FINGERPRINT_SESSION_KEY = 'device-fingerprint-session-key';

const EXCLUSION_PATHS = [
    '/',
    '/about',
    '/press',
    '/contact-us',
    '/referrals',
    '/404',
    '/careers',
    '/invites',
    '/careers',
    '/educators',
    '/activation',
    '/unsupported',
    '/terms/terms-of-service',
    '/terms/terms-of-service-original',
    '/terms/privacy',
    '/terms/privacy-original',
    '/client-relationships'
];

export const PROMO_POPUP_EXCLUSION_PATHS = [
    ...EXCLUSION_PATHS,
    '/',
    '/getstarted'
];

export const PROMO_BANNER_EXCLUSION_PATHS = [...EXCLUSION_PATHS];

export const VARIANT_OPTIONS = ['a', 'b', 'c', 'd', 'e', 'f'];

export const INITIAL_DOLLAR_AMOUNT = 14123;

export const CAPTERRA_REVIEWS = {
    rating: 4.8,
    totalReviews: 598,
    bestRating: '5',
    worstRating: '1',
    url: 'https://www.capterra.com/p/162588/HoneyBook/',
    iconUrl: 'marketing_site/pricing/ratings/Capterra_logo_2x.png'
};
export const G2_REVIEWS = {
    rating: 4.5,
    totalReviews: 158,
    bestRating: '5',
    worstRating: '1',
    url: 'https://www.g2.com/products/honeybook/reviews',
    iconUrl: 'marketing_site/pricing/ratings/g2-color.png'
};
export const APPLE_REVIEWS = {
    rating: 4.8,
    totalReviews: 13900,
    bestRating: '5',
    worstRating: '1',
    url: 'https://apps.apple.com/us/app/honeybook-small-business-crm/id1104772757',
    iconUrl: 'marketing_site/pricing/ratings/appleAppStore.png'
};

export const INITIAL_EMAIL_SIGNATURE_DISPLAY_VALUE = {
    imageUrl:
        'https://res.cloudinary.com/honeybook/image/upload/v1693999725/marketing_site/email-signature/signature-image-empty-state.png',
    name: 'Gunther Anders',
    jobTitle: 'Founder',
    company: "Gunther's Barista Academy",
    email: 'gunther@gunthersbaristas.com',
    address: '199 Lafayette St, New York, NY 10012, USA',
    phone: '210-559-2358',
    website: 'https://www.gunthersbaristas.com',
    facebookUrl: '_',
    twitterUrl: '_',
    linkedinUrl: '_',
    instagramUrl: '_',
    pinterestUrl: '_',
    youtubeUrl: '_',
    selectedTemplateName: 'conservative'
};

export const REFERRAL_DISCOUNT_KEY = 'referralDiscount';

export const TEMPLATE_SELECTION_STORAGE_KEY = 'hb_template_selection';

export const PERSONALIZED_TEMPLATE_STORAGE_KEY = 'hb_personalized_template';
export const MULTY_VALUES_COMPANY_ENTRIES_INDICATOR = '_vers_';

export interface TemplateItem {
    label: string;
    value: string;
}

export interface CompanyTypeTemplate {
    label: string;
    value: string;
    templateTypes: {
        [key in GeneratedTemplateType]?: TemplateItem[];
    };
}

// Maps UTM terms to company type values
export const UTM_TERM_TO_COMPANY_TYPE: Record<string, string> = {
    photo: 'photographer',
    catering: 'caterer',
    caterer: 'caterer',
    'event planner': 'event_planning',
    'event planning': 'event_planning',
    wedding: 'event_planning',
    florist: 'florist',
    florists: 'florist',
    cinematographer: 'cinematography',
    dj: `dj_musician${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}DJ`,
    videograph: 'cinematography',
    makeup: `hair_makeup${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}makeup artist`,
    esthetician: `hair_makeup${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}makeup artist`,
    'hair stylist': `hair_makeup${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}hairdresser`,
    venue: 'venue',
    floral: 'florist',
    'wedding venue': 'venue',
    'event space': 'venue',
    'manager event': 'event_planning',
    agency: 'marketing_agency',
    'advertising agency': 'marketing_agency',
    advertising: 'digital_marketing',
    marketing: 'digital_marketing',
    'marketing agency': 'marketing_agency',
    designer: 'graphic_designer',
    'web design': 'web_designer',
    'social media': 'social_media',
    contractor: 'contractor',
    cleaning: 'cleaning',
    doula: 'doula',
    accounting: `accounting${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}accountant`,
    accountant: `accounting${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}accountant`,
    consultant: 'business_consultant',
    'marketing consultant': 'marketing_consulting',
    coach: 'coaching',
    'interior design': 'interior_designer'
};

export const COMPANY_TYPE_TEMPLATES: CompanyTypeTemplate[] = [
    {
        label: 'accountant',
        value: `accounting${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}accountant`,
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'baker',
        value: 'cake',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'catering contract',
                    value: 'catering_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'agreement amendment',
                    value: 'agreement_amendment'
                }
            ]
        }
    },
    {
        label: 'blogger',
        value: 'blogger',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'brand ambassador contract',
                    value: 'brand_ambassador_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'bookkeeper',
        value: `accounting${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}bookkeeper`,
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'business consultant',
        value: 'business_consultant',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'non-disclosure agreement',
                    value: 'non_disclosure_agreement'
                }
            ]
        }
    },
    {
        label: 'caterer',
        value: 'caterer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'catering contract',
                    value: 'catering_contract'
                },
                {
                    label: 'event planning contract',
                    value: 'event_planning_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'cleaner',
        value: 'cleaning',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'home services contract',
                    value: 'home_services_contract'
                },
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'coach',
        value: 'coaching',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'coaching contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'content creator',
        value: 'content_creation',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'brand ambassador contract',
                    value: 'brand_ambassador_contract'
                },
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'digital marketer',
        value: 'digital_marketing',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'social media services contract',
                    value: 'social_media_services_contract'
                },
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                }
            ]
        }
    },
    {
        label: 'DJ',
        value: `dj_musician${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}DJ`,
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'DJ contract',
                    value: 'dj_contract'
                },
                {
                    label: 'equipment rental contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'doula',
        value: 'doula',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'coaching contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'waiver of liability agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    },
    {
        label: 'educator',
        value: `education${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}educator`,
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'coaching contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'event planner',
        value: 'event_planning',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'event planning contract',
                    value: 'event_planning_contract'
                },
                {
                    label: 'equipment rental contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'fashion stylist',
        value: 'fashion',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'brand ambassador contract',
                    value: 'brand_ambassador_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'design approval',
                    value: 'design_approval'
                }
            ]
        }
    },
    {
        label: 'florist',
        value: 'florist',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'equipment rental contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'event planning contract',
                    value: 'event_planning_contract'
                }
            ]
        }
    },
    {
        label: 'general contractor',
        value: 'contractor',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'residential interior design services contract',
                    value: 'residential_interior_design_services_contract'
                },
                {
                    label: 'home services contract',
                    value: 'home_services_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'graphic designer',
        value: 'graphic_designer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'design approval',
                    value: 'design_approval'
                },
                {
                    label: 'social media services contract',
                    value: 'social_media_services_contract'
                }
            ]
        }
    },
    {
        label: 'hairdresser',
        value: `hair_makeup${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}hairdresser`,
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'makeup artist contract',
                    value: 'makeup_artist_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'waiver of liability agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    },
    {
        label: 'health & wellness coach',
        value: 'wellness',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'coaching contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'interior designer',
        value: 'interior_designer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'residential design contract',
                    value: 'residential_design_contract'
                },
                {
                    label: 'home services contract',
                    value: 'home_services_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'landscaper',
        value: 'landscape',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'landscaping contract',
                    value: 'landscaping_contract'
                },
                {
                    label: 'home services contract',
                    value: 'home_services_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'makeup artist',
        value: `hair_makeup${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}makeup artist`,
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'makeup artist contract',
                    value: 'makeup_artist_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'waiver of liability agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    },
    {
        label: 'marketing agency',
        value: 'marketing_agency',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'social media services contract',
                    value: 'social_media_services_contract'
                },
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'marketing consultant',
        value: 'marketing_consulting',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'social media services contract',
                    value: 'social_media_services_contract'
                },
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'musician',
        value: `dj_musician${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}musician`,
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'DJ contract',
                    value: 'dj_contract'
                },
                {
                    label: 'equipment rental contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'photographer',
        value: 'photographer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'photography contract',
                    value: 'photography_contract'
                },
                {
                    label: 'appearance release agreement',
                    value: 'appearance_release_agreement'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'realtor',
        value: 'real_estate',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                }
            ]
        }
    },
    {
        label: 'rental business owner',
        value: 'rental',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'equipment rental contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'waiver of liability agreement',
                    value: 'waiver_of_liability_agreement'
                },
                {
                    label: 'venue rental contract',
                    value: 'venue_rental_contract'
                }
            ]
        }
    },
    {
        label: 'social media manager',
        value: 'social_media',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'social media services contract',
                    value: 'social_media_services_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                }
            ]
        }
    },
    {
        label: 'tutor',
        value: `education${MULTY_VALUES_COMPANY_ENTRIES_INDICATOR}tutor`,
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'coaching contract',
                    value: 'coaching_contract'
                },
                {
                    label: 'consulting contract',
                    value: 'consulting_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'venue owner',
        value: 'venue',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'venue rental contract',
                    value: 'venue_rental_contract'
                },
                {
                    label: 'equipment rental contract',
                    value: 'equipment_rental_contract'
                },
                {
                    label: 'waiver of liability agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    },
    {
        label: 'videographer',
        value: 'cinematography',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'videographer contract',
                    value: 'videographer_contract'
                },
                {
                    label: 'photography contract',
                    value: 'photography_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                }
            ]
        }
    },
    {
        label: 'virtual assistant',
        value: 'virtual_assistant',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'retainer contract',
                    value: 'retainer_contract'
                },
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'social media services contract',
                    value: 'social_media_services_contract'
                }
            ]
        }
    },
    {
        label: 'visual artist',
        value: 'visual_artist',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'design approval',
                    value: 'design_approval'
                },
                {
                    label: 'agreement amendment',
                    value: 'agreement_amendment'
                }
            ]
        }
    },
    {
        label: 'web designer',
        value: 'web_designer',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'design approval',
                    value: 'design_approval'
                },
                {
                    label: 'non-disclosure agreement',
                    value: 'non_disclosure_agreement'
                }
            ]
        }
    },
    {
        label: 'other',
        value: 'other',
        templateTypes: {
            [GeneratedTemplateType.CONTRACT]: [
                {
                    label: 'services agreement',
                    value: 'services_agreement'
                },
                {
                    label: 'non-disclosure agreement',
                    value: 'non_disclosure_agreement'
                },
                {
                    label: 'waiver of liability agreement',
                    value: 'waiver_of_liability_agreement'
                }
            ]
        }
    }
];
